import styled from 'styled-components';

export const Header = styled.button<{ $collapsible?: boolean }>`
	font-size: 11px;
	font-weight: 800;
	color: ${({ theme }) => theme.gray[400]};
	text-transform: uppercase;
	letter-spacing: 0.06em;
	white-space: nowrap;
	display: flex;
	align-items: center;
	gap: 8px;
	background: none;
	border: none;
	padding: 0;
	width: 100%;
	text-align: left;
	margin-bottom: 8px;
	&:hover {
		color: ${({ theme, $collapsible }) =>
			$collapsible !== false ? theme.gray[600] : theme.gray[400]};
	}

	&::after {
		content: '';
		width: 100%;
		height: 1px;
		background: linear-gradient(-90deg, transparent 0%, rgba(156, 163, 175, 0.2) 100%);
		margin-right: 8px;
	}
`;

export const Chevron = styled.span<{ $isCollapsed: boolean }>`
	display: flex;
	align-items: center;
	flex-shrink: 0;
	transition: transform 0.2s ease;
	transform: rotate(${({ $isCollapsed }) => ($isCollapsed ? '0deg' : '90deg')});
`;

export const Body = styled.div<{ $isCollapsed: boolean }>`
	display: grid;
	grid-template-rows: ${({ $isCollapsed }) => ($isCollapsed ? '0fr' : '1fr')};
	transition: grid-template-rows 0.2s ease;

	> div {
		overflow: hidden;
	}
	margin-bottom: 4px;
`;
